(function(){
  var mq = window.matchMedia('(max-width:820px)');

  // Mobile nav overlay
  var b = document.querySelector('[data-menu-toggle]'), m = document.getElementById('mnav');
  if (b && m) {
    b.addEventListener('click', function(){
      var open = m.hasAttribute('data-open');
      if (open) { m.removeAttribute('data-open'); b.setAttribute('aria-expanded','false'); b.textContent = 'Menu'; document.body.style.overflow = ''; }
      else { var hw = document.querySelector('.eli-headwrap'); if (hw) m.style.paddingTop = Math.round(hw.getBoundingClientRect().bottom + 12) + 'px'; m.setAttribute('data-open',''); b.setAttribute('aria-expanded','true'); b.textContent = 'Close'; document.body.style.overflow = 'hidden'; }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && m.hasAttribute('data-open')) b.click();
    });
  }

  // Accordions: open on desktop, only the first open on mobile
  function syncAcc(){
    var groups = {};
    document.querySelectorAll('details[data-m-acc]').forEach(function(d){
      var g = d.getAttribute('data-m-acc') || 'x';
      (groups[g] = groups[g] || []).push(d);
    });
    Object.keys(groups).forEach(function(g){
      groups[g].forEach(function(d, i){
        if (mq.matches) {
          if (d.hasAttribute('data-m-acc-closed')) d.removeAttribute('open');
          else if (i === 0) d.setAttribute('open','');
          else d.removeAttribute('open');
        }
        else d.setAttribute('open','');
      });
    });
  }
  syncAcc();
  if (mq.addEventListener) mq.addEventListener('change', syncAcc);

  // Chip rail: mark the chip for the section in view
  var chips = document.querySelectorAll('.m-chips a');
  if (chips.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        chips.forEach(function(c){
          var on = c.getAttribute('href') === '#' + en.target.id;
          c.style.background = on ? '#121212' : '';
          c.style.color = on ? '#FDFDFD' : '';
        });
      });
    }, { rootMargin: '-100px 0px -70% 0px' });
    document.querySelectorAll('[data-chip-target]').forEach(function(s){ io.observe(s); });
  }
})();
